import { Sprout } from "lucide-react";

const ITEMS = [
  "Nurturing minds",
  "Empowering learning",
  "Building happier communities",
  "Better learning",
  "Brighter futures",
  "Learn",
  "Grow",
  "Connect",
];

export default function Marquee() {
  const row = (hidden) => (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-heading text-xl md:text-2xl italic text-nh-deep whitespace-nowrap px-6 md:px-10">
            {item}
          </span>
          <Sprout className="h-4 w-4 text-nh-green/70" strokeWidth={1.75} />
        </span>
      ))}
    </div>
  );
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-nh-deep/10 bg-nh-yellow/25 py-5"
    >
      <div className="flex w-max animate-nh-marquee">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
